import { cn } from '@/lib/utils';

export function Avatar({ name, size = 'md', className }: { name: string; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const initials = name.split(/\s+|@/).filter(Boolean).slice(0, 2).map(s => s[0]?.toUpperCase() ?? '').join('');
  const dims = size === 'sm' ? 'h-7 w-7 text-xs' : size === 'lg' ? 'h-12 w-12 text-base' : 'h-9 w-9 text-sm';
  // Color hash
  const hash = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const colors = ['bg-red-600', 'bg-blue-600', 'bg-emerald-600', 'bg-amber-600', 'bg-violet-600', 'bg-cyan-600', 'bg-pink-600', 'bg-orange-600'];
  return (
    <div className={cn('rounded-full flex items-center justify-center text-white font-semibold shrink-0', dims, colors[hash % colors.length], className)}>
      {initials || '?'}
    </div>
  );
}
